import DebugBreakPoint from "./DebugBreakPoint";
import DebugJSON from "./DebugJSON";

const exportObjs = {
  BreakPoint: DebugBreakPoint,
  JSON: DebugJSON,
};

export default exportObjs;
